import React from 'react';
import { Link } from 'react-router-dom';
const NavBar: React.FC = () => {
  return <nav className="bg-white shadow-md p-4 mb-6" data-id="element-40">
      <div className="container mx-auto flex justify-between items-center" data-id="element-41">
        <Link to="/" className="text-xl font-bold text-blue-800" data-id="element-42">
          Periodic Table Explorer
        </Link>
      </div>
    </nav>;
};
export default NavBar;